import { useLocation, Link } from "react-router-dom"

const Footer = () => {
    const location = useLocation()
    return (
        <div className="w-full fixed bottom-0 left-0 mt-40 h-16 bg-black">
            {location.pathname === "/sign-up" || location.pathname === "/verify"
                ? [
                    <p
                        key={Math.random()}
                        className="text-white text-base font-bold text-center leading-64"
                    >
                        Already have an account?{" "}
                        <span className="text-logoRed"><Link to="/sign-in">Sign In</Link></span>
                    </p>,
                ]
                : [
                    <p
                        key={Math.random()}
                        className="text-white text-base font-bold text-center leading-64"
                    >
                        Don't have an account?{" "}
                        <span className="text-logoRed"><Link to="/sign-up">Sign Up</Link></span>
                    </p>,
                ]}
        </div>
    )
}

export default Footer